import { Component, OnInit } from '@angular/core';
import { UserApi, MechanicsApi } from "../../shared/sdk/services";
import { usoCfdi, } from "../catalogos-cfdi";
import moment from 'moment';

@Component({
  selector: 'app-facturacion',
  templateUrl: './facturacion.component.html',
  styleUrls: ['./facturacion.component.scss']
})
export class FacturacionComponent implements OnInit {

  viewable: boolean = false;
  desde;
  hasta;
  displayedColumns: string[] = ['select', 'x_studio_uso_cfdi', 'state', 'x_studio_facturador_estatus', 'x_studio_folio_interno', 'payments', 'create_uid', 'date_order', 'partner_id', 'amount_tax', 'amount_total', 'pricelist_id', 'pos_reference', 'etiqueta'];
  tickets;
  ticketsFiltro;
  ticketsBD;
  loading: boolean = false;
  loadingPercentaje;
  dataCuantos = <any>{};
  query = <any>{};
  seleccionados = {};
  metodoBusca;
  usoCfdi: any = usoCfdi;

  constructor(
    private userApi: UserApi,
    private mechanicsApi: MechanicsApi
  ) {
    if (!this.userApi.isAuthenticated()) {
      window.location.replace("");
    } else {
      this.viewable = true;
    }
  }

  ngOnInit() {
    this.desde = new Date();
    this.hasta = new Date();
    this.obtenCuantosTickets();
  }

  obtenCuantosTickets() {
    this.tickets = [];
    this.loadingPercentaje = 0;
    this.loading = true;
    this.mechanicsApi.cuentaTickets(moment(this.desde).format(), moment(this.hasta).format(), this.query).subscribe((data) => {
      this.dataCuantos = data;
      let veces = Math.ceil(this.dataCuantos.cuantos / this.dataCuantos.limitBusca);
      this.obtenTickets(veces, 0);
    });
  }

  obtenTickets(veces, pag) {
    this.mechanicsApi.odooTickets(moment(this.desde).format(), moment(this.hasta).format(), pag, this.query).subscribe((tickets) => {
      if (tickets) {
        for (let i = 0; i < tickets.length; i++) {
          const ticket = tickets[i];
          ticket.date_order = moment(ticket.date_order).subtract(5, 'hours').format();
          this.seleccionados[ticket.id] = false;
        }
        this.ticketsBD = this.tickets.concat(tickets);
        this.tickets = this.tickets.concat(tickets);
      }
      if (veces) {
        this.loadingPercentaje = this.tickets.length * 100 / this.dataCuantos.cuantos;
        veces--;
        pag++;
        this.obtenTickets(veces, pag);
      } else {
        this.loading = false;
      }
    });
  }

  seleccionaTodo(event) {
    for (const ticket in this.seleccionados) {
      if (this.seleccionados.hasOwnProperty(ticket)) {
        this.seleccionados[ticket] = event.checked;
      }
    }
  }

  timbrarMasivo() {
    this.loading = true;
    let tickets = [];
    for (const ticket in this.seleccionados) {
      if (this.seleccionados.hasOwnProperty(ticket) && this.seleccionados[ticket]) {
        for (let i = 0; i < this.tickets.length; i++) {
          if (this.tickets[i].id == ticket) {
            tickets.push({ ticket: ticket, usoCfdi: this.tickets[i].x_studio_uso_cfdi, partner_id: this.tickets[i].partner_id });
          }
        }
      }
    }
    this.mechanicsApi.timbrarMasivo(tickets).subscribe((data) => {
      console.log(data);

      this.obtenCuantosTickets();
    });
  }

  toggleBuscaPartner(ticket) {
    console.log(ticket);
    if (!ticket.buscaTicket) {
      ticket.buscaTicket = true;
    } else {
      delete ticket.buscaTicket;
      delete ticket.busca;
      delete ticket.buscaRes;
    }
  }

  buscaPartner(ticket) {
    console.log(ticket.busca);
    this.mechanicsApi.buscaPartner({ busca: ticket.busca }).subscribe((data) => {
      ticket.buscaRes = data;
    });
  }

  selecPartner(ticket, partner) {
    ticket.partner_id = [partner.id, partner.name];
    this.toggleBuscaPartner(ticket);
  }

  cancelarMasivo() {
    if (confirm('Estas seguro de querer cancelar los CFDIs seleccionados?')) {
      this.loading = true;
      let tickets = [];
      for (const ticket in this.seleccionados) {
        if (this.seleccionados.hasOwnProperty(ticket) && this.seleccionados[ticket]) {
          tickets.push(ticket);
        }
      }
      this.mechanicsApi.cancelarMasivo(tickets).subscribe(() => {
        this.obtenCuantosTickets();
      });
    }
  }

}
